import * as ASSETS_IMG from "@/assets/img"
import * as ASSETS_DATA from "@/assets/data"

const THEMED_COLORS = {
  dark: {
    // Main colors (use flatten color no alpha)
    accent: "#8b8b8b",
    secondary: "#BCC5D5",
    primary: "#FFFFFF",

    error: "#FF6669",
    info: "#CCDBFA",
    success: "#00a953",
    warning: "#FFC837",

    // Custom general colors
    blue: "#345afa",
    grey: "#8E98AC",
    white: "#FFFFFF",

    // Custom background colors
    bgTable: "#27344E",
    background: "#05122F",
    bgAppBar: "#05122F",
    bgCard: "#27344E",
    bgDrawerContent: "#1C2844",
    bgDrawerApp: "#002F5F"
  },
  light: {
    // Main colors (use flatten color no alpha)
    accent: "#000000",
    primary: "#002F5F",
    secondary: "#33597F",

    error: "#FF6669",
    info: "#CCDBFA",
    success: "#00a953",
    warning: "#FFC837",

    // Custom general colors
    blue: "#345afa",
    grey: "#66829F",
    white: "#FFFFFF",

    // Custom background colors
    bgTable: "#FFFFFF",
    background: "#CCD5DF",
    bgAppBar: "#FFFFFF",
    bgCard: "#FFFFFF",
    bgDrawerContent: "#F2F5F7",
    bgDrawerApp: "#002F5F"
    
  }
}

export default {
  // general configuration
  general: {
    api: process.env.VUE_APP_ROOT_API,
    url: process.env.VUE_APP_DOMAIN,
    name: {
      full: process.env.VUE_APP_NAME || "GWASSOU",
      abbr: process.env.VUE_APP_ABBR || "IO"
    },
    assets: {
      img: ASSETS_IMG,
      data: ASSETS_DATA
    }
  },
  // plugins configuration
  plugins: {
    gtag: {
      id: process.env.VUE_APP_GTAG || "G-8KW0N34207"
    },
    i18n: {
      locale: process.env.VUE_APP_I18N_LOCALE || "en",
      fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
      localeDir: "assets/data/locales",
      enableInSFC: true
    },
    vuetify: {
      theme: {
        dark: false,
        themes: THEMED_COLORS
      }
    }
  }
}
